var MyPlugin = {}
MyPlugin.install = function (Vue, options) {
    Vue.prototype.test=function(){
        alert(1)
    }
    Date.prototype.Format = function(fmt)   { 
               var o = {
            "M+": this.getMonth() + 1, //月份   
            "d+": this.getDate(), //日   
            "h+": this.getHours(), //小时   
            "m+": this.getMinutes(), //分   
            "s+": this.getSeconds(), //秒   
            "q+": Math.floor((this.getMonth() + 3) / 3), //季度   
            "S": this.getMilliseconds() //毫秒   
        };
        if (/(y+)/.test(fmt))
            fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;  
      } 
    // Vue.prototype.Format = function(fmt)   { 
    //     var d = new Date(fmt)
    //     fmt = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
    //     console.log(fmt)
    //     return fmt 
    //  } 
};
export  default MyPlugin



// WEBPACK FOOTER //
// ./src/utils/common.js